(function () {
  function bind(root) {
    if (!root || root.dataset.mmCrevBound === 'true') return;
    root.dataset.mmCrevBound = 'true';

    var track = root.querySelector('.mm-crev__track');
    var slides = root.querySelectorAll('[data-mm-crev-slide]');
    var prev = root.querySelector('[data-mm-crev-prev]');
    var next = root.querySelector('[data-mm-crev-next]');
    if (!track || slides.length < 1) return;

    var index = 0;

    function goTo(nextIndex) {
      if (slides.length === 0) return;
      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -(index * 100) + '%)';
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var startX = 0;
    var dragging = false;
    var viewport = root.querySelector('[data-mm-crev-track]');

    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        dragging = true;
        startX = e.changedTouches[0].clientX;
      }, { passive: true });

      viewport.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    goTo(0);
  }

  function initAll() {
    document.querySelectorAll('[data-mm-crev]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-mm-crev]');
    if (root) {
      delete root.dataset.mmCrevBound;
      bind(root);
    }
  });
})();
